import type { ReactNode } from 'react'

interface ScreenProps {
  children: ReactNode
  /** Ingen plads reserveret til bundnavigationen (fx login-skærme). */
  bare?: boolean
  /** Centrerer indholdet lodret i stedet for at starte fra toppen (fx login). */
  center?: boolean
}

function Screen({ children, bare = false, center = false }: ScreenProps) {
  return (
    <div className="mx-auto min-h-screen max-w-[430px] border border-text-2/20 bg-[radial-gradient(120%_60%_at_30%_0%,var(--color-felt-2),var(--color-felt)_70%)] md:max-w-[560px] md:border-0 md:text-[17px] lg:max-w-[640px]">
      <main
        className={`grid min-h-screen gap-3.5 px-4 pt-4 ${center ? 'content-center' : 'content-start'} ${
          bare ? 'pb-6' : 'pb-[calc(84px+env(safe-area-inset-bottom,0px))]'
        }`}
      >
        {children}
      </main>
    </div>
  )
}

export default Screen
